import React from 'react';
import { Grid } from '@material-ui/core';
import { TextField, AddressField, SwitchField, Step } from '../SteppedForm';

import rules from './rules';

const StepPersonalcontact = (props) => {
  return (
    <Step
      id="personalcontact"
      title={props.getPersonalDetailsTitle('Contact Details')}
      skip={(formdata) => formdata.onboardingFor === 'vehicle'}>
      <Grid container>
        <Grid item xs={12} lg={6}>
          <TextField id="email" label="Email" valid={rules.email} required />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            id="mobile"
            label="Mobile Phone"
            type="tel"
            inputProps={{ maxLength: 16 }}
            valid={rules.phone}
            required
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          {props.state.formdata.orgtype === 'individual' ? (
            <>
              <AddressField id="home" label="Address" country="AU" fetchDetails required />
            </>
          ) : (
            <div className="composite">
              <AddressField
                id="home"
                label="Home Address"
                country="AU"
                fetchDetails
                suppressOptional
                value={
                  props.getApplicant().corp_as_home
                    ? props.state.formdata.hqaddress
                    : props.getApplicant().home
                }
                valid={(v) =>
                  props.getApplicant().home || props.getApplicant().corp_as_home
                    ? true
                    : 'Is a required field'
                }
                disabled={props.getApplicant().corp_as_home}
              />

              <SwitchField
                id="corp_as_home"
                label={'Use ' + props.state.formdata.orgtype + ' address'}
                color="secondary"
                checked={props.getApplicant().corp_as_home ? true : false}
              />
            </div>
          )}
        </Grid>
        <Grid item xs={12} lg={6}>
          <div className="composite">
            <AddressField
              id="postal"
              label="Postal Address"
              country="AU"
              fetchDetails
              suppressOptional
              value={
                props.getApplicant().home_as_postal
                  ? props.getHomeAddress()
                  : props.getApplicant().postal
              }
              valid={(v) =>
                props.getApplicant().postal || props.getApplicant().home_as_postal
                  ? true
                  : 'Is a required field'
              }
              disabled={props.getApplicant().home_as_postal}
            />
            <SwitchField
              id="home_as_postal"
              label="Use Home Address"
              color="secondary"
              checked={props.getApplicant().home_as_postal ? true : false}
            />
          </div>
        </Grid>
      </Grid>
    </Step>
  );
};

export default StepPersonalcontact;
